module.exports = __webpack_public_path__ + "img/CloseWhite.ee413240.svg";